// app-pages/ContactUs/ContactUsForm.tsx
"use client";
import { useState } from "react";
import { Flex, Textarea, Input, Button, Text } from "@chakra-ui/react";

export default function ContactUsForm({ data }: { data: any }) {
  const [formData, setFormData] = useState({
    subject: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    setSuccess(false);

    try {
      const response = await fetch("https://api.deepmode.ai/users/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      const responseData = await response.json();
      console.log(responseData);
      setSuccess(true);
    } catch (error) {
      setError(true);
      console.error("There was a problem with the fetch operation:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Flex mt="30px" direction="column">
          {data?.data.attributes.Blocks[0].FormField.map((field: any) =>
            field.Label.toLowerCase().replace(/ /g, "") === "message" ? (
              <Textarea
                key={field.id}
                bg="#1A1D21"
                border="1px solid #363A3D"
                placeholder={field.Placeholder}
                name={field.Label.toLowerCase().replace(/ /g, "")}
                required={field.Required}
                value={
                  formData[field.Label.toLowerCase().replace(/ /g, "") as keyof typeof formData]
                }
                onChange={handleChange}
                mb="8px"
              />
            ) : (
              <Input
                key={field.id}
                bg="#1A1D21"
                border="1px solid #363A3D"
                placeholder={field.Placeholder}
                name={field.Label.toLowerCase().replace(/ /g, "")}
                type={field.Type || "text"}
                required={field.Required}
                value={
                  formData[field.Label.toLowerCase().replace(/ /g, "") as keyof typeof formData]
                }
                onChange={handleChange}
                mb="8px"
              />
            )
          )}
          <Button
            type="submit"
            bg="button.500"
            color="white"
            isLoading={loading}
            _hover={{ opacity: 0.9 }}
          >
            Submit
          </Button>
        </Flex>
      </form>
      {success && (
        <Text color="green.500" mt="4">
          Message sent successfully!
        </Text>
      )}
      {error && (
        <Text color="red.500" mt="4">
          Failed to send message. Please try again.
        </Text>
      )}
    </>
  );
}
